import React from 'react'
import {AnnotationIcon} from '@heroicons/react/outline'
import { useRecoilState } from 'recoil'
import { quizInput } from '../../recoil/quiz';

const QuestionInput = () => {
  const [input, setInput] = useRecoilState(quizInput);
  
  const changeQuestion = (question) => {
    let newInput = {...input};
    newInput.question = question;
    setInput(newInput);
  }

  return (
    <div className="flex flex-col items-start">
        <label htmlFor="question" className="text-sm">Soal <span className="text-xs text-red-500">{"(wajib diisi)"}</span></label>
        <div className="flex items-start w-full gap-5 px-5 py-3 mt-2 rounded-lg bg-slate-50">
            <AnnotationIcon className="w-6 h-6" />
            <textarea onChange={e => changeQuestion(e.target.value)} value={input.question} name="question" id="question" rows="3" className="w-full p-0 bg-transparent border-none focus:ring-0" placeholder="Soal"></textarea>
        </div>
    </div>
  )
}

export default QuestionInput